
import blogData from '@/data/blog.json'
export default {
  name: 'Pagination',
  props: {
    offset: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      total: 0,
      totalPages: 0,
      count: 0,
      maxVisibleButtons: 10,
    }
  },
  async fetch() {
    this.total = await blogData.total
    this.totalPages = Math.ceil(this.total / 10)
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.$props.offset === 1) {
        return 1
      }

      // When on the last page
      if (this.$props.offset === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons
      }

      // When inbetween
      return this.$props.offset - 1
    },
    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      )
    },
    pages() {
      const range = []

      for (
        let i = this.startPage;
        i <=
        Math.min(this.startPage + this.maxVisibleButtons - 5, this.totalPages);
        i++
      ) {
        range.push({
          name: i,
          isDisabled: i === this.$props.offset,
        })
      }

      return range
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return this.currentPage === this.totalPages
    },
  },
  methods: {
    onClickFirstPage() {
      this.$store.$router.push('/blog/page/1/')
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.$props.offset - 1)
    },
    onClickPage(page) {
      this.$emit('pagechanged', page)
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.$props.offset + 1)
    },
    onClickLastPage() {
      this.$store.router.push('/blog/page/' + this.totalPages + '/')
    },
    isPageActive(page) {
      return this.currentPage === page
    },
  },
}
